+<template>
  <div>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col sm="12 my-3">
        <b-form-group class="mb-0">
          <b-form-checkbox
            v-for="option in productAddons"
            :key="option.value"
            v-model="productAddon"
            :value="option.value"
            :checked="option.checked"
            :disabled="option.disabled"
            name="productAddon"
            inline
            >{{ option.text }}</b-form-checkbox
          >
        </b-form-group>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false, regex: /^[A-Za-z0-9 ]+$/ }"
          validattor="^[A-Za-z0-9]+$"
          type="text"
          name="referenceNumber"
          maxlength="15"
          label-content="Reference Number"
          :class="{
            input: true,
            'is-danger': errors.has('referenceNumber'),
          }"
          :placeholder="placeholders.referenceNumber"
        ></BaseEInputText>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="companyName"
          v-model="companyName"
          v-validate="'required'"
          type="text"
          name="companyName"
          maxlength="100"
          mark-required
          label-content="Company Name"
          data-vv-as="Company name"
          :class="{
            input: true,
            'is-danger': errors.has('companyName'),
          }"
          :placeholder="placeholders.companyName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('companyName') }} </div>
      </b-col>

      <b-col md="3">
        <BaseEInputText
          id="TaxID"
          v-model="taxID"
          v-validate="{
            required: false,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="taxID"
          label-content="Tax ID"
          data-vv-as="Tax ID"
          :class="{
            input: true,
            'is-danger': errors.has('taxID'),
          }"
          :placeholder="placeholders.taxID"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('taxID') }} </div>
      </b-col>

      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('phoneNumber') }} </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          v-validate="'required'"
          type="text"
          name="streetAddress"
          maxlength="50"
          label-content="Street"
          data-vv-as="Street"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('streetAddress'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('streetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[.A-Za-z -]+$/ }"
          validattor="^[.A-Za-z -]+$"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          data-vv-as="City"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('cityName'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('cityName') }} </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          :field-id="state"
          :options="stateDetails"
          class="mb-1"
          name="state"
          data-vv-as="State"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div class="error"> {{ errors.first('state') }} </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          data-vv-as="Zip"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row class="mt-3" align-v="center">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Principal / Guarantor Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="PrincipalFirstName"
          v-model="PrincipalFirstName"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
            regex: /^[A-Za-z0-9-]+$/,
          }"
          validattor="^[A-Za-z0-9-]+$"
          type="text"
          name="PrincipalFirstName"
          maxlength="50"
          label-content="First Name"
          data-vv-as="First Name"
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
              ? true
              : false
          "
          :class="{
            input: true,
            'is-danger': errors.has('PrincipalFirstName'),
          }"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('PrincipalFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="PrincipalMiddleName"
          v-model="PrincipalMiddleName"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          type="text"
          name="PrincipalMiddleName"
          maxlength="50"
          label-content="Middle Name"
          data-vv-as="Middle Name"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('PrincipalMiddleName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="PrincipalLastName"
          v-model="PrincipalLastName"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
            regex: /^[A-Za-z0-9-]+$/,
          }"
          validattor="^[A-Za-z0-9-]+$"
          type="text"
          name="PrincipalLastName"
          maxlength="50"
          label-content="Last Name"
          data-vv-as="Last Name"
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
              ? true
              : false
          "
          :class="{
            input: true,
            'is-danger': errors.has('PrincipalLastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('PrincipalLastName') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="ssn"
          v-model="PrincipalSSN"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
            regex: /^\d{3}-?\d{2}-?\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{2})(\d{4})"
          formatter="$1-$2-$3"
          type="text"
          maxlength="11"
          name="PrincipalSSN"
          label-content="SSN"
          data-vv-as="SSN"
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
              ? true
              : false
          "
          :class="{
            input: true,
            'is-danger': errors.has('PrincipalSSN'),
          }"
          :placeholder="placeholders.ssn"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('PrincipalSSN') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="PrincipalPhoneNumber"
          v-model="PrincipalPhoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="PrincipalPhoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :class="{
            input: true,
            'is-danger': errors.has('PrincipalPhoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('PrincipalPhoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col md="5">
        <BaseEInputText
          id="principalStreetAddress"
          v-model="principalStreetAddress"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
          }"
          type="text"
          name="principalStreetAddress"
          maxlength="50"
          label-content="Street"
          data-vv-as="Street"
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
              ? true
              : false
          "
          :class="{
            input: true,
            'is-danger': errors.has('principalStreetAddress'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('principalStreetAddress') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="principalCityName"
          v-model="principalCityName"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
            regex: /^[.A-Za-z -]+$/,
          }"
          validattor="^[.A-Za-z -]+$"
          type="text"
          name="principalCityName"
          maxlength="20"
          label-content="City"
          data-vv-as="City"
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
              ? true
              : false
          "
          :class="{
            input: true,
            'is-danger': errors.has('principalCityName'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('principalCityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
          "
          label="State"
        />
        <BaseDropdown
          v-model="principalState"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
          }"
          :field-id="principalState"
          :options="stateDetails"
          class="mb-1"
          name="principalState"
          data-vv-as="State"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div class="error"> {{ errors.first('principalState') }} </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="principalZip"
          v-model="principalZip"
          v-validate="{
            required:
              productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
                ? true
                : false,
            regex: /^[0-9]{5}(?:-[0-9]{4})?$/,
          }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="principalZip"
          label-content="Zip"
          data-vv-as="Zip"
          :mark-required="
            productAddon.indexOf(30) > -1 || productAddon.indexOf(44) > -1
              ? true
              : false
          "
          :class="{
            input: true,
            'is-danger': errors.has('principalZip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('principalZip') }} </div>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col md="auto">
        <BaseEButton name="search" @click="onReportSearch">
          Search
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>

<script>
import { orderReportMethods, toasterMethods, userMethods } from '@state/helpers'
import constant from '@constants/constant'
export default {
  props: {
    productAddOns: {
      type: Array,
      default: Array,
    },
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    searchData: {
      type: String,
      default: '',
    },
    refineSearchAddOns: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      referenceNumber: '',
      bcirPrincipal: 0,
      Borrower: {},
      productAddons: [],
      productAddon: [],
      companyName: '',
      showSpinner: false,
      taxID: '',
      phoneNumber: '',
      streetAddress: '',
      cityName: '',
      state: '',
      stateCode: '',
      zip: '',
      PrincipalFirstName: '',
      PrincipalMiddleName: '',
      PrincipalLastName: '',
      PrincipalSSN: '',
      PrincipalPhoneNumber: '',
      principalStreetAddress: '',
      principalCityName: '',
      principalState: '',
      principalStateCode: '',
      principalZip: '',
      requestData: '',
    }
  },
  computed: {
    placeholders() {
      return {
        companyName: 'Company Name',
        taxID: 'xxx-xx-xxxx',
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        ssn: 'xxx-xx-xxxx',
        streetAddress: 'Street Address',
        cityName: 'City Name',
        state: 'Select State',
        zip: 'xxxxx-xxxx',
        phoneNumber: '(xxx) xxx-xxxx',
        legaldescription: 'Legal Description',
        referenceNumber: 'Reference Number',
      }
    },

    stateDetails() {
      return this.$_allStates
    },
  },

  mounted() {
    this.reset()
    this.getBCIR2ReportAddons()
    if (this.searchData.length > 0) {
      this.loadRefineSearch()
    }
  },
  methods: {
    ...userMethods,
    ...orderReportMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    getBCIR2ReportAddons() {
      for (var i = 0; i < this.productAddOns.length; i++) {
        this.productAddons.push({
          value: this.productAddOns[i].productAddOnId,
          text: this.productAddOns[i].name,
          checked: this.productAddOns[i].defaultScope,
          disabled: !this.productAddOns[i].changeable,
        })
        if (this.productAddOns[i].defaultScope === true) {
          this.productAddon.push(this.productAddOns[i].productAddOnId)
        }
      }
    },

    reset() {
      this.companyName = ''
      this.taxID = ''
      this.phoneNumber = ''
      this.streetAddress = ''
      this.cityName = ''
      this.state = ''
      this.zip = ''
      this.PrincipalMiddleName = ''
      this.PrincipalLastName = ''
      this.PrincipalPhoneNumber = ''
      this.PrincipalSSN = ''
      this.principalStreetAddress = ''
      this.principalCityName = ''
      this.principalState = ''
      this.principalZip = ''
    },

    loadRefineSearch() {
      if (
        this.searchData !== undefined &&
        this.searchData !== null &&
        this.searchData.length > 0
      ) {
        this.showSpinner = true
        this.searchData = JSON.parse(this.searchData)

        this.productAddons = []
        for (var i = 0; i < this.refineSearchAddOns.length; i++) {
          this.productAddons.push({
            value: this.refineSearchAddOns[i].productAddOnId,
            text: this.refineSearchAddOns[i].name,
            checked: this.refineSearchAddOns[i].defaultScope,
            disabled: !this.refineSearchAddOns[i].changeable,
          })
          if (this.refineSearchAddOns[i].defaultScope === true) {
            this.productAddon.push(this.refineSearchAddOns[i].productAddOnId)
          }
        }
        this.referenceNumber =
          this.searchData.ReferenceNumber !== ''
            ? this.searchData.ReferenceNumber
            : ''
        this.companyName = this.searchData.BusinessName
        this.taxID = this.searchData.TaxId !== '' ? this.searchData.TaxId : ''
        this.phoneNumber =
          this.searchData.Contacts.PhoneNumber !== ''
            ? this.searchData.Contacts.PhoneNumber
            : ''
        this.streetAddress =
          this.searchData.Address.Street !== ''
            ? this.searchData.Address.Street
            : ''
        this.cityName =
          this.searchData.Address.City !== ''
            ? this.searchData.Address.City
            : ''
        this.state =
          this.searchData.Address.StateId !== ''
            ? this.searchData.Address.StateId
            : ''
        this.zip =
          this.searchData.Address.Zip !== '' ? this.searchData.Address.Zip : ''
        this.PrincipalFirstName =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.FirstName !== ''
            ? this.searchData.Borrower.FirstName
            : ''
        this.PrincipalMiddleName =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.MiddleName !== ''
            ? this.searchData.Borrower.MiddleName
            : ''
        this.PrincipalLastName =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.LastName !== ''
            ? this.searchData.Borrower.LastName
            : ''
        this.PrincipalPhoneNumber =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.Contacts.PhoneNumber !== ''
            ? this.searchData.Borrower.Contacts.PhoneNumber
            : ''
        this.PrincipalSSN =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.SSN !== ''
            ? this.searchData.Borrower.SSN
            : ''
        this.principalStreetAddress =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.Address !== null &&
          this.searchData.Borrower.Address.Street !== ''
            ? this.searchData.Borrower.Address.Street
            : ''
        this.principalCityName =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.Address !== null &&
          this.searchData.Borrower.Address.City !== ''
            ? this.searchData.Borrower.Address.City
            : ''
        this.principalState =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.Address !== null &&
          this.searchData.Borrower.Address.StateId !== ''
            ? this.searchData.Borrower.Address.StateId
            : ''
        this.principalZip =
          this.searchData.Borrower !== null &&
          this.searchData.Borrower.Address !== null &&
          this.searchData.Borrower.Address.Zip !== ''
            ? this.searchData.Borrower.Address.Zip
            : ''
      }
      this.showSpinner = false
    },

    buildSearchRequest() {
      if (this.PrincipalFirstName !== '') {
        this.Borrower = JSON.stringify({
          FirstName: this.PrincipalFirstName,
          MiddleName:
            this.PrincipalMiddleName !== '' ? this.PrincipalMiddleName : '',
          LastName: this.PrincipalLastName,
          BorrowerType: 0,
          SSN: this.PrincipalSSN,
          Address: {
            Street: this.principalStreetAddress,
            City: this.principalCityName,
            StateId: this.principalState,
            StateCode: this.principalStateCode,
            Zip: this.principalZip,
          },
          PreviousAddress: null,
          Contacts: {
            PhoneNumber: this.PrincipalPhoneNumber,
            PhoneType: 0,
          },
          NumberOfDependents: null,
          Email: null,
        })
      }
      return (this.requestData = JSON.stringify({
        BCIRAddons: this.productAddon,
        BusinessName: this.companyName,
        TaxId: this.taxID,
        Contacts: {
          PhoneNumber: this.phoneNumber,
          PhoneType: 0,
        },

        Address: {
          Street: this.streetAddress,
          City: this.cityName,
          StateId: this.state,
          StateCode: this.stateCode,
          Zip: this.zip,
        },
        Borrower:
          this.PrincipalFirstName !== '' ? JSON.parse(this.Borrower) : null,
        UserId: this.currentUserId,
        OrderForCustomer: this.customerId,
        OrderForUser: this.customerUserId,
        ProductId: this.productId,
        ReferenceNumber:
          this.referenceNumber !== '' && this.referenceNumber !== undefined
            ? this.referenceNumber
            : '',
      }))
    },

    onReportSearch(selectedValue) {
      this.getStateCode()
      let userInfo = this.$store.state.auth.currentUser.userInfo
      var isOrderReportComponentValid = false
      var isBCIR2ReportComponentValid = false
      this.currentUserId = userInfo.userId
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        that.$validator.validate().then((response) => {
          if (userInfo.roles.indexOf(constant.CreditAnalystOrLoanOfficer) !== -1) {
            isOrderReportComponentValid = response
            that.customerUserId = that.currentUserId
          }
          isBCIR2ReportComponentValid = response
          if (isOrderReportComponentValid && isBCIR2ReportComponentValid) {
            if ((that.firstName && that.lastName) || that.companyName !== '') {
              that.showSpinner = true
              that.requestData = that.buildSearchRequest()
              return that
                .fetchSearchCompanyResult({
                  searchRequest: that.requestData,
                })
                .then((response) => {
                  if (
                    response !== undefined &&
                    response.data !== undefined &&
                    response.data.result.responseStatus !== 0
                  ) {
                    // Getting selected Addons and updating productAddOns object.
                    for (var i = 0; i < that.productAddon.length; i++) {
                      for (var j = 0; j < that.productAddOns.length; j++) {
                        if (
                          that.productAddon[i] ===
                          that.productAddOns[j].productAddOnId
                        ) {
                          that.productAddOns[j].defaultScope = true
                        }
                      }
                    }

                    that.$router.push({
                      name: 'bcir2Summary',
                      params: {
                        searchResponse: response.data,
                        searchRequest: that.requestData,
                        searchFor: that.companyName,
                        refineSearchAddOns: that.productAddOns,
                      },
                    })
                  } else if (
                    response.data &&
                    response.data.result &&
                    response.data.result.message
                  ) {
                    // this.getModal(response.data.result.message, 'Message')
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: response.data.result.message,
                      variant: constant.errorMessagetype,
                    })
                    that.showSpinner = false
                  } else {
                    that.showSpinner = false
                    this.setAlert({
                      title: constant.imageHeaderError,
                      msg: constant.errorMessage,
                      variant: constant.errorMessagetype,
                    })
                  }
                })
                .catch((error) => {
                  that.authError = error
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                })
            }
          }
        })
      })
    },
    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.stateDetails.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
  },
}
</script>
